import { render, staticRenderFns } from "./ModalShutdownReseller.vue?vue&type=template&id=620dbce2"
import script from "./ModalShutdownReseller.vue?vue&type=script&lang=js"
export * from "./ModalShutdownReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports